<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2022-11-04 14:13:06
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressHome.vue
 * @Description: 项目进度查询和办理 - 首页
 */
 -->

<template>
  <div id="project-progress" class="project-progress">
    <head-search
      @searchQuery="search"
      @searchCancel="onCancel"
      placeholder="请输入 业务编号/测绘单位/工程名称"
    ></head-search>
    <van-tabs class="tabs" v-model="active" color="#1989fa" @click="onClick">
      <van-tab v-for="(item, i) in statusConfig" :title="item.label" :name="item.value" :key="i"></van-tab>
    </van-tabs>
    <div class="project-progress-box">
      <no-data v-if="list.length == 0"></no-data>
      <van-pull-refresh v-model="refreshConfig.refreshing" @refresh="onRefresh">
        <van-list
          class="job-list"
          v-model="refreshConfig.loading"
          :finished="refreshConfig.finished"
          :finished-text="refreshConfig.finishedText"
          :error.sync="refreshConfig.error"
          :error-text="refreshConfig.errorText"
          @load="onLoad"
        >
          <div class="list">
            <div class="list-item" v-for="(item, i) in list" :key="i">
              <div class="top">
                <img src="@/assets/img/opinionPublish/home_icon.png">
                <div class="title">{{ item.GCMC }}</div>
              </div>
              <div class="middle">
                <div class="info">
                  <div class="label">项目编号</div>
                  <div class="value">{{ item.YWBH }}</div>
                </div>
                <div class="info">
                  <div class="label">建设单位</div>
                  <div class="value">{{ item.JSDW }}</div>
                </div>
                <div class="info">
                  <div class="label">发布时间</div>
                  <div class="value">{{ item.CREATETIME }}</div>
                  <div class="status"
                    :class="{
                      'yellow': item.DQZT == '测量中',
                      'red': item.DQZT == '被退件' || item.DQZT == '被退回',
                      'green': item.DQZT == '待确认',
                      'blue': item.DQZT == '测量完成',
                    }"
                  >{{ item.DQZT }}</div>
                </div>
              </div>
              <div class="bottom" @click="checkDetail(item)">
                <span>详情</span>
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import HeadSearch from '@/components/HeadSearch.vue'
import commonApi from '@/utils/api/common.js'
import api from '@/utils/api/projectProgress.api'
import listMixins from '@/mixins/comListMixins'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'projectProgressHome',
  mixins: [listMixins, moduleMixins],
  components: {
    HeadSearch,
    NoData
  },
  props: {},
  data() {
    return {
      loading: false, //加载
      finished: false, //是否已加载完成
      refreshing: false, //下拉刷新
      searchValue: '', // 搜索条件
      statusConfig: [],
      active: -1,
      list: [], // 业务列表
      columns: [], // 列表子项的左侧标题数组
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return this.$route.query.title
    }
  },
  methods: {
    // 搜索项目进度查询和办理数据
    search(val) {
      console.log('搜索值', val)
      this.searchValue = val
      this.onRefresh()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.searchValue = ''
      this.onRefresh()
    },
    onClick() {
      this.loadData({
        page: 1,
        rows: 20
      })
    },
    // 点击"详情"按钮，查看详情
    checkDetail(data) {
      console.log('--详情--', data)
      this.$router.push({
        name: 'projectProgressDetail',
        params: data
        // params: {
        //   unitName: data[this.columns[1].key],
        //   rid: data.RID,
        //   YWLX: data.YWLX,
        //   XMZTBM: data.XMZTBM,
        //   XMZTXZ: data.XMZTXZ
        // }
      })
    },
     //加载获取项目进度查询和办理数据列表
     loadData(data) {
      const loading = this.$toast.loading()
      let params = {
        page: data.page,
        pageSize: data.rows,
        type: this.active,
        rid: this.$store.state.userInfo.RID,
        keyword: this.searchValue
      }
      return api.getProjectList(params).then(res => {
        loading.clear()
        console.log('--res', res.data)
        let rList = res.data.rowsList ? res.data.rowsList : []
        this.columns = res.data.columns
        if (data.page == 1) {
          this.list = rList
        } else {
          this.list.push(...rList)
        }
        this.finished = this.list.length >= res.data.total
        return Promise.resolve(res)
      })
    },
    loadDict() {
      //先要判断vuex有没有保存字典
      if (Object.keys(this.$store.state.projectCode).length == 0) {
        commonApi.lookupDict({code: 'CLSX'}).then(res => {
          res.data.forEach(element => {
            commonApi.lookupDict({code: element.code}).then(res => {
              console.log('--res: ', res)
              this.$store.commit('setProjectCode', res.data)
            })
          })
        })
      }
    },
    loadConfig() {
      api.getStatusConfig().then(res => {
        this.statusConfig = res.data.tabs[0].options
      })
    }
  },
  created() {},
  mounted() {
    //   this.loadData()
    this.loadConfig()
    this.loadDict()
  }
}
</script>
<style lang="scss" scoped>
.project-progress {
  position: relative;
  height: calc(100vh - 95px);
  .tabs {
    position: fixed;
    top: 45px;
    left: 0px;
    z-index: 9;
  }
  .project-progress-box {
    // height: calc(100vh - 47px);
    background: #f1f3f6;
    // overflow: auto;
    padding: 110px 15px 0;
    box-sizing: border-box;
    .job-list {
      height: 100%;
      .list {
        overflow-y: auto;
        &-item {
          background-color: #fff;
          border-radius: 5px;
          margin-bottom: 20px;
          .top {
            display: flex;
            align-items: center;
            margin: 0 10px;
            border-bottom: 1px solid #F1F3F6;
            img {
              width: 50px;
              padding: 10px;
              padding-left: 0;
            }
            .title {
              font-weight: bold;
            }
          }
          .middle {
            padding: 10px;
            .info {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              font-size: 14px;
              position: relative;
              .label {
                width: 80px;
                color: #999;
              }
              .value {
                flex: 1;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .status {
                margin-right: 1rem;
                padding: 3px 8px;
                color: #333;
                background-color: #ddd;
                &.yellow {
                  color: #D78534;
                  background-color: #FFEBCC;
                }
                &.red {
                  color: #FA6366;
                  background-color: #FFD5D5;
                }
                &.green {
                  color: #34CC8C;
                  background-color: #DCF4EA;
                }
                &.blue {
                  color: #155EDE;
                  background-color: #D5E4FF;
                }
              }
            }
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #F1F3F6;
            padding: 10px;
            i {
              color: #999;
            }
          }
        }
      }
    }
  }
}
</style>
